export function InputVal({
    value="",
    wrapContent,
})
{
    return <div dangerouslySetInnerHTML={{__html:value}}/>
}